//- Automatically import every scripts
import './libs/**/*.js';
import './scripts/**/*.js';